import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store(
    {
        state    : {
            csrf         : null,
            countries    : null,
        },
        mutations: {
            setCsrf(state, value) {
                state.csrf = value;
            },
            updateCountries(state, data) {
                state.countries = data;
            }
        },
        actions  : {
            loadCountries({commit}) {
                commit('updateCountries', {});
                return axios.get('/countries').then((res) => {
                    commit('updateCountries', res.data.map((item) => {
                        return {
                            id           : item.id,
                            text         : item.name,
                            useibanandbic: item.useibanandbic,
                            iso          : item.iso,
                        }
                    }));
                });
            }
        }
    }
);

export default store;
